import { useEffect } from "react";
import { usePostHog } from "@posthog/react";

function isDemoPath(): boolean {
  if (typeof window === "undefined") return false;
  return window.location.pathname === "/demo";
}

/**
 * Stops session replay on `/demo` to save quota and avoid recording throwaway UI;
 * resumes when navigating away (popstate / SPA updates that touch `pathname`).
 */
export function PostHogSessionRecordingGate() {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    const sync = () => {
      try {
        if (isDemoPath()) posthog.stopSessionRecording();
        else posthog.startSessionRecording();
      } catch {
        /* ignore */
      }
    };

    sync();
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, [posthog]);

  return null;
}
